import { ContactLookupSettings } from "@signalist/shared-types";

import { FunctionComponent } from "react";
import { Trans, useTranslation } from "react-i18next";

import { CreditConfirmModal } from "@/components/CreditConfirmModal";

import { previewQuote } from "./previewQuoteSegments";

interface PreviewExtendCreditConfirmProps {
	/** The additional companies the extension searches. */
	additionalCount: number;
	/** The list's contact lookup settings, which the extension runs like a preview does. */
	contactLookups: ContactLookupSettings;
	onClose: () => void;
	/** Starts the extension; rejects when the API refuses it. */
	onConfirm: () => Promise<unknown>;
}

/**
 * The credit-confirm of Extend Preview (PREC-5028): the additional companies and the contact
 * lookups the list's settings add, each at its shared price and decided by what the run finds,
 * with `additionalCount * PREVIEW_COMPANY_CREDITS` as what the API checks the balance against
 * before it starts — the same quote Start Preview shows (PREC-4263 review M2). The extension
 * starts only from here.
 */
export const PreviewExtendCreditConfirm: FunctionComponent<PreviewExtendCreditConfirmProps> = ({
	additionalCount,
	contactLookups,
	onClose,
	onConfirm,
}) => {
	const { t } = useTranslation();
	const count = additionalCount;
	const { segments, requiredToStart } = previewQuote(count, contactLookups, t);

	return (
		<CreditConfirmModal
			isOpened
			body={
				<Trans
					components={{ b: <b className="font-semibold" /> }}
					i18nKey="creditConfirm.previewExtend.body"
					values={{ count }}
				/>
			}
			chargeNote={t("creditConfirm.previewExtend.chargeNote")}
			confirmLabel={t("creditConfirm.previewExtend.confirm", { count })}
			requiredToStart={requiredToStart}
			segments={segments}
			title={t("creditConfirm.previewExtend.title")}
			onClose={onClose}
			onConfirm={onConfirm}
		/>
	);
};
